import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { LevelInterface } from '../../+models';
import { LevelsActions, LevelsActionTypes } from './level.actions';

export const NAME = 'levels';

export interface State extends EntityState<LevelInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export function sortLevels(a: LevelInterface, b: LevelInterface): number {
  return a.sequence - b.sequence;
}

export const adapter: EntityAdapter<LevelInterface> = createEntityAdapter<LevelInterface>({
  sortComparer: sortLevels,
});

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: LevelsActions): State {
  switch (action.type) {
    case LevelsActionTypes.LevelsLoaded: {
      return adapter.setAll(action.payload.levels, {
        ...state,
        loaded: true,
      });
    }

    case LevelsActionTypes.LevelsLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
